import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

// project imports
import axios from 'utils/axios';

// types
import { DefaultRootStateProps } from 'types';

type GetLogsType = {
    merchantId?: number | null;
    productId?: string | null;
    page?: number;
};

const initialState: DefaultRootStateProps['reports'] = {
    error: null,
    loading: false,
    changeLog: {
        logs: [],
        totalPages: 0
    },
    changeLogUsers: [],
    aiLogs: {
        logs: []
    }
};

const reports = createSlice({
    name: 'reports',
    initialState,
    reducers: {},
    extraReducers(builder) {
        // CHANGE LOG
        builder
            .addCase(getChangeLogList.pending, (state) => {
                state.loading = true;
            })
            .addCase(getChangeLogList.fulfilled, (state, action) => {
                state.loading = false;
                state.changeLog = { logs: action.payload.response, totalPages: action.payload.totalPages };
            })
            .addCase(getChangeLogUsers.pending, (state) => {
                state.loading = true;
            })
            .addCase(getChangeLogUsers.fulfilled, (state, action) => {
                state.loading = false;
                state.changeLogUsers = action.payload;
            })
            .addCase(getAiLogs.pending, (state) => {
                state.loading = true;
            })
            .addCase(getAiLogs.fulfilled, (state, action) => {
                state.loading = false;
                state.aiLogs = {
                    logs: action.payload
                };
            });
    }
});

export default reports.reducer;

export const getChangeLogList = createAsyncThunk(
    `${reports.name}/getChangeLogList`,
    async ({ merchantId, productId, page = 1 }: GetLogsType) => {
        const response = await axios.get(`/loolu/api/multicatalog/product/changelogsearch`, {
            params: {
                merchantId: merchantId || 1,
                productId,
                page,
                limit: 100
            }
        });

        return response.data;
    }
);

export const getChangeLogUsers = createAsyncThunk(`${reports.name}/getChangeLogUsers`, async (idMerchant: number | null) => {
    const response = await axios.get(`/loolu/api/logs/users`, {
        params: {
            idMerchant: idMerchant || 1
        }
    });
    return response.data;
});

export const getAiLogs = createAsyncThunk(`${reports.name}/getAiLogs`, async () => {
    const response = await axios.get(`/loolu/api/genAI/logIA`);

    return response.data;
});
